import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";

export class PollCaosConfigurationUpdateStatusResData extends ApiGenericResponse {
    installationsUpdateIsFinished: Map<string, number>;

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.InstallationsUpdateIsFinished) {
            this.installationsUpdateIsFinished = new Map<string, number>();
            for (const [key, value] of Object.entries(obj.InstallationsUpdateIsFinished)) {
                this.installationsUpdateIsFinished.set(key, value as number);
            }
        }
    }
}
